import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-foreground-400 mb-3 block">
            FAQ
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Domande Frequenti
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Le risposte alle domande più comuni su Itaobuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {faqItems.map((faq, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-background-200/70 overflow-hidden"
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => toggleFAQ(i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-background-50 transition-colors cursor-pointer"
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4" itemProp="name">
                  {faq.question}
                </h3>
                <span className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIndex === i ? 'bg-primary-100 text-primary-600 rotate-45' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className="ri-add-line text-base"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === i ? 'max-h-[1200px] opacity-100' : 'max-h-0 opacity-0'
                }`}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <div className="px-6 pb-5" itemProp="text">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}